/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Button, Icon } from "components/Component";
import { Modal, ModalBody, Spinner } from "reactstrap";
import { getDepartments } from "services/departments";

const ChatModalFilterDepartment = (props) => {
  const {
    cookies,
    roleFunctions,
    isModalDepartmentFilterOpen,
    setIsModalDepartmentFilterOpen,
    setFilterDepartment,
    filterDepartment,
  } = props;

  const [search, setSearch] = useState("");
  const [departmentList, setDepartmentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredDepartmentList, setFilteredDepartmentList] = useState([]);
  const [selectedFilterItem, setSelectedFilterItem] = useState([]);

  const handleCheckboxClicked = (e, department) => {
    if (e.target.checked) {
      setSelectedFilterItem([...selectedFilterItem, department.id]);
    } else {
      const newFilter = selectedFilterItem.filter((id) => id !== department.id);
      setSelectedFilterItem(newFilter);
    }
  };

  const refreshDepartmentsList = async () => {
    setLoading(true);
    try {
      // getDepartments is role-aware: ALL_DEPT gets every department,
      // OWN_DEPT/OWN only gets the user's own departments
      const response = await getDepartments(
        cookies.SIDikey,
        "",
        cookies.departmentIds,
        cookies.id,
        roleFunctions,
        100,
      );

      if (new RegExp(/20+/).test(response.status)) {
        const data = response.data.data;
        setDepartmentList(data);
        setFilteredDepartmentList(data);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
    } finally {
      setLoading(false);
    }
  };

  const chooseFilterDepartment = () => {
    setFilterDepartment([...new Set(selectedFilterItem)]);
    setIsModalDepartmentFilterOpen(false);
  };

  // Load departments when modal opens
  useEffect(() => {
    if (isModalDepartmentFilterOpen === true) {
      refreshDepartmentsList();
      setSelectedFilterItem(filterDepartment); // Set dari filter yang sudah ada
    }
  }, [isModalDepartmentFilterOpen]);

  // Filter departments by search
  useEffect(() => {
    if (search !== "") {
      const filtered = departmentList.filter((department) =>
        department.name?.toLowerCase().includes(search.toLowerCase()),
      );
      setFilteredDepartmentList(filtered);
    } else {
      setFilteredDepartmentList(departmentList);
    }
  }, [search, departmentList]);

  return (
    <Modal
      isOpen={isModalDepartmentFilterOpen}
      backdrop="static"
      keyboard={false}
      toggle={() => setIsModalDepartmentFilterOpen(false)}
      className="modal-dialog-centered"
    >
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setIsModalDepartmentFilterOpen(false);
            setSearch("");
            setSelectedFilterItem(filterDepartment);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="mb-4">
          <h5>Filter by Department</h5>
        </div>
        <div className="form-control-wrap">
          <div className="form-icon form-icon-left">
            <Icon name="search"></Icon>
          </div>
          <input
            type="text"
            className="form-round form-control"
            placeholder="Search Department Name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div style={{ maxHeight: 350, overflowY: "auto" }} className="mt-2 filter">
          {loading ? (
            <div className="d-flex justify-content-center align-item-stretch py-4">
              <Spinner animation="border" role="status" color="blue" />
            </div>
          ) : filteredDepartmentList.length > 0 ? (
            filteredDepartmentList.map((department) => (
              <div className="card-inner-md" key={department.id} style={{ cursor: "pointer" }}>
                <div className="user-card">
                  <input
                    type="checkbox"
                    name="department"
                    onChange={(e) => handleCheckboxClicked(e, department)}
                    className="mr-2"
                    checked={selectedFilterItem.includes(department.id)}
                  />
                  <span className="text-dark font-weight-medium">{department.name}</span>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-4 text-muted">
              {search ? "No departments found" : "No departments available"}
            </div>
          )}
        </div>
        <div className="d-flex justify-content-around mt-3">
          <Button
            color="primary"
            onClick={() => chooseFilterDepartment()}
            className="col-6"
            style={{ width: "100%", justifyContent: "center" }}
          >
            Apply Filter
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ChatModalFilterDepartment;
